module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/opcje-321c8588314bfd040315e640a205635b.svg";